import {
  createStore as reduxCreateStore,
  compose,
  applyMiddleware,
} from "redux";
import { createEpicMiddleware } from "redux-observable";
import reduxReset from "redux-reset";
import { composeWithDevTools } from "@redux-devtools/remote";

import { reducers } from "./reducers";
import { epics } from "./epics";

// Epics Middleware
const epicsMiddleware = createEpicMiddleware();

// Chrome Dev Tools Redux Debugger
const composeEnhancers =
  typeof window === "object" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({})
    : compose;

// const composeEnhancers = composeWithDevTools({
//   name: "Spectre App",
//   realtime: true,
//   hostname: "192.168.1.8",
//   port: 8000,
// });

const enhancer = composeEnhancers(
  applyMiddleware(epicsMiddleware),
  reduxReset()
);

const createStore = () => {
  const store = reduxCreateStore(reducers, enhancer);
  epicsMiddleware.run(epics);

  return store;
};
export default createStore;
